import React from "react";
import { Grid } from "@material-ui/core";
import Product from './Product/Product';
import useStyles from './styles';

// const products = [
//     { id: 1, name: "Shoes", description: "Running shoes." , price:' ₹499', image: 'https://media.istockphoto.com/photos/running-shoes-picture-id1249496770?b=1&k=20&m=1249496770&s=170667a&w=0&h=_SUv4odBqZIzcXvdK9rqhPBIenbyBspPFiQOSDRi-RI=' },
//     { id: 2, name: "Macbook", description: "Apple macbook." , price:' ₹50,000', image: 'https://images.unsplash.com/photo-1569770218135-bea267ed7e84?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8bWFjYm9vayUyMHByb3xlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60' },
   
    
// ];
const Products = ({products, onAddToCart}) => { 
    const classes = useStyles();
    return(
        <main className={classes.content}>
            <div className={classes.toolbar}/>
        <Grid container justify="center" spacing={4}>
            {products.map((product) => (
                <Grid item key={product.id} xs={12} sm={6} md={4} lg={3}>
                    <Product product={product} onAddToCart={onAddToCart}/>
                </Grid>
            ))}
        </Grid>
    </main>
    )
  
}

export default Products;